import { alpha, tableCellClasses } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles<
  void,
  | "table"
  | "row"
  | "headTableCell"
  | "bodyTableCell"
  | "actionsWrapper"
  | "overlayActionWrapper"
  | "sortIcon"
  | "rowIconWrapper"
>()(({ spacing }, _, classes) => ({
  table: {
    borderCollapse: "separate"
  },
  tableBody: {
    overflowY: "auto"
  },
  row: {
    "&:nth-of-type(2n + 1)": {
      backgroundColor: alpha(blueGrey[50], 0.5)
    },

    [`& .${tableCellClasses.root}`]: {
      borderTop: `1px solid transparent`,
      borderBottom: `1px solid transparent`,

      "&:first-of-type": {
        borderLeft: `1px solid transparent`
      },
      "&:last-of-type": {
        borderRight: `1px solid transparent`
      }
    },

    "&:hover": {
      backgroundColor: alpha(blueGrey[50], 1)
    },
    "&:focus, &:focus-within": {
      outline: `3px solid ${alpha(lightBlue[200], 0.2)}`,

      [`& .${tableCellClasses.root}`]: {
        borderColor: lightBlue[300]
      }
    },
    "&:hover, &:focus, &:focus-within": {
      [`& .${tableCellClasses.root}`]: {
        [`& > .${classes.actionsWrapper}`]: {
          visibility: "visible"
        },
        [`& > .${classes.overlayActionWrapper}`]: {
          display: "block"
        },
        [`& > .${classes.rowIconWrapper}`]: {
          display: "none"
        }
      }
    }
  },
  headTableCell: {
    padding: spacing(2, 1, 2),
    borderBottom: `2px solid ${blueGrey[200]}`,
    userSelect: "none",

    [`&:hover .${classes.sortIcon}`]: {
      color: blueGrey[500]
    }
  },
  sortableHeadTableCell: {
    cursor: "pointer"
  },
  bodyTableCell: {
    padding: spacing(1),

    "&:first-of-type": {
      paddingRight: spacing(0)
    }
  },
  emptyPlaceholder: {
    color: blueGrey[500],
    textAlign: "center"
  },
  actionTableCell: {
    boxSizing: "content-box",
    width: "30px" // TODO: Check this.
  },
  actionsWrapper: {
    visibility: "hidden"
  },
  startActionsWrapper: {
    marginRight: "auto",
    justifyContent: "start"
  },
  endActionsWrapper: {
    marginLeft: "auto",
    justifyContent: "end"
  },
  overlayActionWrapper: {
    display: "none"
  },
  sortIcon: {
    fontSize: "0.75rem",
    color: blueGrey[400],
    cursor: "pointer"
  },
  rowIconWrapper: {
    display: "block"
  }
}))
